module.exports = __webpack_public_path__ + "static/media/Palme.7edbb23f.PNG";